import {Separator} from "@/components/ui/separator";

const Table = () => {
  const frequencies = {
    98: 'Koné, Koumac, Poum, Ouégoa, Kaala-Gomen, Pouebo, Hienghène, Touho',
    99: 'Bourail, Moindou, La Foa, Farino, Sarraméa',
    100: 'Boulouparis, La Couvelle, Yaté, Mont-Dore, Dumbéa',
    100.4: 'Lifou, Maré, Ouvéa',
    101: 'Belep',
    101.5: 'Nouméa, Païta',
    102.5: 'Thio, Canala',
    103.5: 'Poya, Poindimié'
  }

  return (
    <div className="grid md:grid-cols-10 mt-12">
      <div className="border rounded border-neutral-200 py-6 px-8 col-start-2 col-end-10">
        <h3 className="mb-6 text-2xl text-neutral-1000">Nos fréquences</h3>

        {Object.keys(frequencies).map((freq, index, array) => (
          <div key={freq}>
            <div className="grid grid-cols-3 md:grid-cols-5 gap-2 items-center">
              <div className="col-end-2 text-brand-mer-500 font-bold text-2xl md:text-[28px]">{freq}</div>
              <div className="col-start-2 col-end-6 text-md md:text-lg">{frequencies[freq]}</div>
            </div>
            {array.length - 1 > index && <Separator className='my-3'/>}
          </div>
        ))
        }
      </div>
    </div>
  )
}

export default Table
